export enum DecryptionState {
    NotStarted,
    NotApplicable,
    InProgress,
    Completed,
    PendingUserAction,
}
